import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { OutboundParcelSchema } from "@redotech/redo-fulfillment-parcel-common/parcel";
import { RateSchema } from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOmsReturnLabelRates = {
  name: "getOmsReturnLabelRates" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shopperAddress: FulfillmentOrderAddressSchema,
    merchantAddress: FulfillmentOrderAddressSchema,
    parcel: OutboundParcelSchema,
  }),
  output: z.object({
    rates: z.array(RateSchema),
    errorMessage: z.string().optional(),
  }),
};
